export default "__VITE_ASSET__DnJJph2a__";